import {init as logDemoInit} from './interactive-logs';
import {init as subscribeFormInit } from './subscribe-form'

(() => {
  function watchForElement(selector, callback) {
    const existingElement = document.querySelector(selector);
    if (existingElement) { callback(existingElement); return; }
    const observer = new MutationObserver((mutations, obs) => {
      const element = document.querySelector(selector);
      if (element) { callback(element); obs.disconnect(); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  watchForElement('#log-viewer-container', (el) => logDemoInit(el));
  watchForElement('#subscribe-form', (el) => subscribeFormInit(el))
  
  console.log('%c So glad you\'re here! But better checkout the app for the full experience!', `font-weight:bold;background-image:linea-gradient(150deg,hsl(337deg 100% 24%) 0%,hsl(331deg 100% 24%) 17%,hsl(323deg 100% 23%) 33%,hsl(312deg 100% 21%) 50%,hsl(305deg 100% 18%) 67%,hsl(295deg 100% 17%) 83%,hsl(284deg 100% 17%) 100%);color:white;border-radius:8px;`);
})();
